import CatLoader from '../components/CatLoader';
import { useState, useEffect } from 'react';
import api from '../api';

const ratingColor = (r) => {
  if (r <= 2) return '#ef4444';
  if (r === 3) return '#f59e0b';
  return '#10b981';
};

const stars = (r) => '★'.repeat(r) + '☆'.repeat(5 - r);

export default function Reviews() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [expanded, setExpanded] = useState({});

  useEffect(() => { load(); }, []);

  const load = async () => {
    setLoading(true);
    try {
      const r = await api.get('/reviews');
      setData(r.data);
    } catch(e) {
      setError(e.response?.data?.error || e.message);
    } finally { setLoading(false); }
  };

  if (loading) return <CatLoader loading={true}/>;

  if (error) return (
    <div style={{ padding:32, color:'var(--red)' }}>Ошибка: {error}</div>
  );

  const articles = data?.articles || [];

  return (
    <div style={{ padding:'24px 32px', maxWidth:1200 }}>
      <div style={{ marginBottom:24, display:'flex', alignItems:'center', justifyContent:'space-between' }}>
        <div>
          <h1 style={{ fontSize:22, fontWeight:700, marginBottom:4 }}>Отзывы с проблемами</h1>
          <div style={{ fontSize:13, color:'var(--text-muted)' }}>
            Артикулы где среди последних 5 отзывов есть оценка ≤ 3 · за 14 дней
            {data?.updatedAt && <span> · обновлено {new Date(data.updatedAt).toLocaleTimeString('ru-RU', {hour:'2-digit',minute:'2-digit'})}</span>}
          </div>
        </div>
      </div>

      {articles.length === 0 && (
        <div style={{ textAlign:'center', padding:64, color:'var(--text-muted)', fontSize:15 }}>
          🎉 Нет артикулов с негативными отзывами за последние 14 дней
        </div>
      )}

      <div style={{ display:'flex', flexDirection:'column', gap:12 }}>
        {articles.map(article => {
          const isExp = expanded[article.article];
          const minRating = Math.min(...article.feedbacks.map(f => f.rating));
          const negCount = article.feedbacks.filter(f => f.rating <= 3).length;

          return (
            <div key={article.article} style={{
              background:'var(--surface)', border:'1px solid var(--border)',
              borderRadius:12, overflow:'hidden',
              borderLeft:`3px solid ${ratingColor(minRating)}`,
            }}>
              <div onClick={() => setExpanded(p => ({...p, [article.article]: !p[article.article]}))}
                style={{ padding:'14px 20px', cursor:'pointer', display:'flex', alignItems:'center', gap:16,
                  background: isExp ? 'rgba(255,255,255,0.03)' : 'transparent' }}>
                <div style={{ flex:1 }}>
                  <div style={{ fontWeight:700, fontSize:15, marginBottom:2 }}>{article.article}</div>
                  <div style={{ fontSize:12, color:'var(--text-muted)' }}>{article.productName}</div>
                </div>
                <div style={{ display:'flex', gap:8, alignItems:'center' }}>
                  <div style={{
                    padding:'3px 10px', borderRadius:20, fontSize:12, fontWeight:600,
                    background:`${ratingColor(minRating)}20`, color:ratingColor(minRating),
                    border:`1px solid ${ratingColor(minRating)}40`,
                  }}>
                    {negCount} негат.
                  </div>
                  <div style={{ fontSize:12, color:'var(--text-muted)' }}>{article.feedbacks.length} отзывов</div>
                  <div style={{ color:'var(--text-muted)', fontSize:16 }}>{isExp ? '▲' : '▼'}</div>
                </div>
              </div>

              {isExp && (
                <div style={{ borderTop:'1px solid var(--border)' }}>
                  {article.feedbacks.map((f, i) => (
                    <div key={i} style={{
                      padding:'12px 20px',
                      borderBottom: i < article.feedbacks.length-1 ? '1px solid rgba(255,255,255,0.05)' : 'none',
                      display:'flex', gap:16, alignItems:'flex-start',
                    }}>
                      <div style={{ flexShrink:0, textAlign:'center', minWidth:60 }}>
                        <div style={{ fontSize:18, color:ratingColor(f.rating) }}>{f.rating}★</div>
                        <div style={{ fontSize:10, color:'var(--text-muted)', marginTop:2 }}>
                          {new Date(f.date).toLocaleDateString('ru-RU', {day:'2-digit',month:'2-digit'})}
                        </div>
                        {f.size && <div style={{ fontSize:10, color:'var(--text-muted)' }}>р.{f.size}</div>}
                      </div>
                      <div style={{ flex:1, fontSize:13, lineHeight:1.5, color:'var(--text)' }}>
                        {f.text || '—'}
                      </div>
                      <div style={{ flexShrink:0 }}>
                        {f.isAnswered && <div style={{
                          fontSize:11, padding:'2px 8px', borderRadius:10,
                          background: 'rgba(16,185,129,0.1)',
                          color: 'var(--green)',
                          border: '1px solid rgba(16,185,129,0.2)',
                        }}>✓ Отвечен</div>}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
